
import React from 'react'
import Box from './Box'

/**
 * Avatar component.
 */

export default function Avatar({ name, size = 3, ...props }) {
  const s = `${size}rem`
  return <Box 
    displayName="Avatar"
    width={s}
    height={s}
    lineHeight={s}
    textAlign="center"
    background={2}
    borderRadius="full"
    textTransform="uppercase"
    fontSize={0}
    userSelect="none"
    backgroundHover={1}
    {...props}
  >
    {initials(name)}
  </Box>
}

/**
 * initials util.
 */

function initials(name) {
  const p = name.split(' ')

  if (p.length > 1) {
    return p[0][0] + p[1][0]
  }

  return p[0][0]
}